// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"bc9b92d8","796":"ccff40e0"}[chunkId] + ".chunk.js";
};